export default __webpack_public_path__ + "static/media/8pics.4b752034.mp4";